import { EntityId, EntityState } from '@reduxjs/toolkit';

import { useGameSelector } from '../../GameStore';

import { InGameHistoryState, InGameHistoryTypes } from './types';

export const useInGameHistorySlice = {
  getInGameHistory: (): EntityState<InGameHistoryTypes, EntityId> & InGameHistoryState => {
    return useGameSelector(({ inGameHistory }) => inGameHistory);
  },
  getIsApiRejected: (): boolean => {
    return useGameSelector(({ inGameHistory }) => inGameHistory.error);
  },
};
